import React from 'react';
import { Grid } from '@material-ui/core';
import { withNotification } from 'wrappers';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { BaseModal, ButtonBase, TextAreaBase } from 'components';
import {
    abreviaturas, masterMessages, messages, masterEvents,
} from 'constantes';
import { PdfViewerBusiness } from 'business/business/PdfViewerBusiness';
import { AnalyticsAmplitud } from 'utils/Analytics-Amplitud';

/**
 * @desc Objeto que evalua si los campos del formulario son correctos
 */
const validationSchema = Yup.object({
    observacion: Yup.string().required('La observación es requerida'),
});

function ModalCancelDoc({
     handleCloseModal, setLoading, solicitudId, appSuccess, appError, onClickModalExit,
   }) {
    // Mensajes mostrar
    const { pdfViewer: { modalDocCancel }, buttons } = masterMessages;
    const values = {
        observacion: '',
    };
    const { observacion } = values || {};

    /**
     * @name mapValues
     * @desc Metodo donde se setean valores segun el api
     * @param formValues
     * @returns {{estado: string, idEstado: number, mensajeError}}
     */
    const mapValues = (formValues) => {
        const { observacion: observacionError } = formValues;

        return {
            estado: abreviaturas.STATUS_ERROR,
            mensajeError: observacionError,
            idEstado: abreviaturas.STATUS_ERROR_ID,
        };
    };

    /**
     * @name onClickModalExit
     * @desc Realiza el cambio de estado con el mensaje de error
     * @param formValues
     * @returns {Promise<void>}
     */
    const onPdfCancel = async (formValues) => {
        setLoading(true);
        try {
            const data = await mapValues(formValues);
            // Se envia solicitud al api
            await PdfViewerBusiness.postDocumentReaderStatus(data, solicitudId);
            // Conexión con analiticas al cancelar firma
            AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_CANCELAR_FIRMA);
            appSuccess(messages.dataFetch.success);
            onClickModalExit();
            setLoading(false);
        } catch (e) {
            setLoading(false);
            appError(messages.dataFetch.fail);
        }
    };

    return (
      <BaseModal
        open
        onClose={handleCloseModal}
        title={modalDocCancel.title}
        message={modalDocCancel.message}
        maxWidth="sm"
      >
        <Formik
          enableReinitialize
          initialValues={{
                    observacion,
                }}
          validationSchema={validationSchema}
          onSubmit={onPdfCancel}
        >
          {(subProps) => (
            <Form noValidate>
              <Grid container alignItems="center" justifyContent="center" spacing={2}>
                <Grid item xs={12} md={12}>
                  <Field name="observacion" label="Observaciones" component={TextAreaBase} />
                </Grid>
                <Grid item xs={6} md={6}>
                  <ButtonBase
                    disabled={subProps.isSubmitting}
                    caption={buttons.send}
                    colorBase={abreviaturas.DEFAULT_RED_COLOR}
                  />
                </Grid>
              </Grid>
            </Form>
                )}
        </Formik>
      </BaseModal>
    );
}

ModalCancelDoc.propTypes = {
    solicitudId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    onClickModalExit: PropTypes.func.isRequired,
    handleCloseModal: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    appSuccess: PropTypes.func.isRequired,
    appError: PropTypes.func.isRequired,
};

export default withNotification(ModalCancelDoc);
